export const SUBDOMAIN = window.location.hostname.split('.')[0];

export const API_ROOT = `${process.env.REACT_APP_API_PROTOCOL}${SUBDOMAIN}.${process.env.REACT_APP_API_DOMAIN}`
  
export const WS_ROOT = `${process.env.REACT_APP_WS_PROTOCOL}${process.env.REACT_APP_API_DOMAIN}`
  